(function () {
  // ===== STEP 3 CONFIG: PUT YOUR REAL SHOPIFY DISCOUNT CODES HERE =====
  const CODE_BUY1 = "buy 1 get 10 off";   // <-- change to your real 10% code
  const CODE_BUY2 = "buy 2 get 15 off";   // <-- change to your real 15% code

  const RULES = [
    { minQty: 2, percent: 15, code: CODE_BUY2, label: "Buy 2+ Get 15% Off" },
    { minQty: 1, percent: 10, code: CODE_BUY1, label: "Buy 1 Get 10% Off" }
  ];

  // Exclude already discounted (sale) items from estimate
  const EXCLUDE_SALE_ITEMS = true;

  function moneyINR(paise) {
    return (paise / 100).toLocaleString("en-IN", { style: "currency", currency: "INR" });
  }

  // Narrative copy ("You save …" / "Extra savings …") — round to nearest ₹5, drop decimals.
  function moneyINRRounded(paise) {
    var rupees = Math.round(paise / 100 / 5) * 5;
    return "₹" + rupees.toLocaleString("en-IN", { maximumFractionDigits: 0 });
  }

  function ensureLineDiscountNodes() {
  const items = document.querySelectorAll('[data-cart-item-key]');
  items.forEach(itemEl => {
    const key = (itemEl.getAttribute('data-cart-item-key') || '').trim();
    const vid = (itemEl.getAttribute('data-cart-variant-id') || '').trim();
    if (!key && !vid) return;

    // Already exists?
    if (itemEl.querySelector('[data-fsb-line-discount]')) return;

    // Best place to append inside the item (price block if present)
    const priceEl =
      itemEl.querySelector('.cart-item__column.cart-item__price') ||
      itemEl.querySelector('.cart-item__price') ||
      itemEl;

    const div = document.createElement('div');
    div.className = 'fsb-line-discount';
    div.setAttribute('data-fsb-line-discount', '');
    div.setAttribute('data-key', key);
    div.setAttribute('data-variant-id', vid);
    div.style.display = 'none';

    priceEl.appendChild(div);
  });
}

  function bestRule(qty) {
    return RULES.slice().sort((a,b) => b.minQty - a.minQty).find(r => qty >= r.minQty) || null;
  }

  async function getCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    return await res.json();
  }

  // ---- Cache product JSON so we don’t refetch repeatedly ----
  const _productCache = new Map();

  async function fetchProduct(handle) {
    if (_productCache.has(handle)) return _productCache.get(handle);
    const p = fetch(`/products/${handle}.js`)
      .then(r => r.json())
      .catch(() => null);
    _productCache.set(handle, p);
    return p;
  }

  async function isCompareAtSaleItem(cartItem) {
    // cartItem has: handle, variant_id
    const product = await fetchProduct(cartItem.handle);
    if (!product || !product.variants) return false;

    const v = product.variants.find(x => String(x.id) === String(cartItem.variant_id));
    if (!v) return false;

    const price = Number(v.price || 0);
    const compare = Number(v.compare_at_price || 0);

    // If compare_at_price exists and is higher than price => already discounted sale item
    return compare > price;
  }

  /** Compute MRP (sum of compare_at_price * qty) in paise. Product JSON may return price in rupees (e.g. 1899) or paise (e.g. 189900). */
  async function computeMRP(cart) {
    let mrpPaise = 0;
    for (const item of cart.items) {
      const product = await fetchProduct(item.handle);
      const qty = item.quantity;
      if (!product || !product.variants) {
        mrpPaise += item.original_line_price || 0;
        continue;
      }
      const v = product.variants.find(x => String(x.id) === String(item.variant_id));
      const compareAtRaw = v ? Number(v.compare_at_price || 0) : 0;
      // If value >= 10000, assume already in paise (e.g. 189900). Else assume rupees (e.g. 1899) and convert.
      const compareAtPaise = compareAtRaw >= 10000 ? compareAtRaw : Math.round(compareAtRaw * 100);
      if (compareAtPaise > 0) {
        mrpPaise += compareAtPaise * qty;
      } else {
        mrpPaise += item.original_line_price || 0;
      }
    }
    return mrpPaise;
  }

  async function computeEligible(cart) {
    let qty = 0;
    let subtotal = 0;

    // Check sale-status for each cart item (cached per product handle)
    const saleFlags = await Promise.all(
      cart.items.map(async (item) => {
        if (!EXCLUDE_SALE_ITEMS) return false;
        return await isCompareAtSaleItem(item);
      })
    );

    cart.items.forEach((item, idx) => {
      if (EXCLUDE_SALE_ITEMS && saleFlags[idx]) return;

      qty += item.quantity;
      subtotal += item.final_line_price; // base for estimate
    });

    return { qty, subtotal, saleFlags };
  }

  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + (days*24*60*60*1000));
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${d.toUTCString()};path=/`;
  }

  function getCookie(name) {
    const m = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return m ? decodeURIComponent(m[2]) : "";
  }

  function deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  }

  /** For items eligible for 10%/15%, show original price struck through and discounted price (like sale items). */
  function renderLineItemStrikeThrough(cart, rule, saleFlags) {
    const percent = rule ? rule.percent / 100 : 0;

    cart.items.forEach((item, idx) => {
      const isSale = saleFlags && saleFlags[idx];
      const eligible = rule && !isSale;
      const row = document.querySelector(`[data-cart-item-key="${item.key}"]`);
      if (!row) return;

      const priceCol = row.querySelector(".cart-item__column.cart-item__price, .cart-item__price");
      const totalCol = row.querySelector(".cart-item__column.cart-item__total, .cart-item__total");

      if (eligible) {
        const originalUnitPaise = item.original_price || item.price || 0;
        const originalLinePaise = item.original_line_price || item.final_line_price || 0;
        const discountedUnitPaise = Math.round(originalUnitPaise * (1 - percent));
        const discountedLinePaise = Math.round(originalLinePaise * (1 - percent));

        if (priceCol) {
          let strikeUnit = priceCol.querySelector(".fsb-struck-unit");
          if (!strikeUnit) {
            strikeUnit = document.createElement("span");
            strikeUnit.className = "struck-out-price small-text fsb-struck-unit";
            strikeUnit.innerHTML = '<span class="theme-money"></span>';
            priceCol.appendChild(strikeUnit);
          }
          const strikeMoney = strikeUnit.querySelector(".theme-money");
          if (strikeMoney) strikeMoney.textContent = moneyINR(originalUnitPaise);
          strikeUnit.style.display = "";

          const sellingPrice = priceCol.querySelector(".cart-item__selling-price");
          if (sellingPrice) sellingPrice.textContent = moneyINR(discountedUnitPaise);
        }

        if (totalCol) {
          let strikeTotal = totalCol.querySelector(".fsb-struck-total");
          if (!strikeTotal) {
            strikeTotal = document.createElement("div");
            strikeTotal.className = "theme-money struck-out-price small-text fsb-struck-total";
            totalCol.insertBefore(strikeTotal, totalCol.firstChild);
          }
          strikeTotal.textContent = moneyINR(originalLinePaise);
          strikeTotal.style.display = "";

          const sellingTotal = totalCol.querySelector(".cart-item__selling-total");
          if (sellingTotal) sellingTotal.textContent = moneyINR(discountedLinePaise);
        }
      } else {
        const strikeUnit = row.querySelector(".fsb-struck-unit");
        const strikeTotal = row.querySelector(".fsb-struck-total");
        if (strikeUnit) strikeUnit.style.display = "none";
        if (strikeTotal) strikeTotal.style.display = "none";
        if (!rule) {
          const sellingPrice = priceCol && priceCol.querySelector(".cart-item__selling-price");
          const sellingTotal = totalCol && totalCol.querySelector(".cart-item__selling-total");
          if (sellingPrice) sellingPrice.textContent = moneyINR(item.final_price || item.price || 0);
          if (sellingTotal) sellingTotal.textContent = moneyINR(item.final_line_price || 0);
        }
      }
    });
  }

  function render(cart, rule, discountPaise, shippingPaise, mrpPaise, eligibleSubtotalPaise) {
    const breakdown = document.getElementById("fsb-cart-breakdown");
    const offersBox = document.getElementById("fsb-offers-box");
    const defaultSubtotal = document.querySelector(".subtotal.h4.heading-font.opposing-items");

    const mrpRow = document.getElementById("fsb-row-mrp");
    const mrpEl = document.getElementById("fsb-mrp");
    const eligibleRow = document.getElementById("fsb-row-eligible");
    const eligibleLabel = document.getElementById("fsb-eligible-label");
    const eligibleAmount = document.getElementById("fsb-eligible-amount");
    const discountRow = document.getElementById("fsb-row-discount");
    const discountEl = document.getElementById("fsb-discount");
    const shippingRow = document.getElementById("fsb-row-shipping");
    const shippingAmountEl = document.getElementById("fsb-shipping-amount");
    const netPayEl = document.getElementById("fsb-net-pay");

    if (!breakdown || !netPayEl) return;

    const netPayPaise = cart.total_price - discountPaise + shippingPaise;

    if (cart.item_count === 0) {
      breakdown.style.display = "none";
      if (defaultSubtotal) defaultSubtotal.style.display = "";
      return;
    }

    breakdown.style.display = "";
    if (defaultSubtotal) defaultSubtotal.style.display = "none";

    if (rule && discountPaise > 0) {
      offersBox.innerHTML = `
        <div class="mm-coupon-box">
          <div class="mm-coupon-content">
            <div class="mm-coupon-text">
              <p>${rule.label} • You save <span class="fsb-save">${moneyINRRounded(discountPaise)}</span></p>
            </div>
          </div>
        </div>
      `;
      setCookie("fsb_discount_code", rule.code, 7);
      if (eligibleRow && eligibleLabel && eligibleAmount && eligibleSubtotalPaise > 0) {
        eligibleRow.style.display = "";
        eligibleLabel.textContent = rule.percent === 15 ? "Before 15% off" : "Before 10% off";
        eligibleAmount.innerHTML = "<s>" + moneyINR(eligibleSubtotalPaise) + "</s>";
      }
    } else {
      offersBox.innerHTML = "";
      deleteCookie("fsb_discount_code");
      if (eligibleRow) eligibleRow.style.display = "none";
    }

    if (mrpRow && mrpEl) {
      if (mrpPaise > 0) {
        mrpRow.style.display = "";
        mrpEl.textContent = moneyINR(mrpPaise);
      } else {
        mrpRow.style.display = "none";
      }
    }

    const totalDiscountPaise = (mrpPaise > 0 ? mrpPaise - cart.total_price : 0) + discountPaise;
    if (discountRow && discountEl) {
      if (totalDiscountPaise > 0) {
        discountRow.style.display = "";
        discountEl.textContent = "- " + moneyINR(totalDiscountPaise);
      } else {
        discountRow.style.display = "none";
      }
    }

    if (shippingRow && shippingAmountEl) {
      shippingRow.style.display = "";
      shippingAmountEl.textContent = moneyINR(shippingPaise);
    }

    netPayEl.textContent = moneyINR(netPayPaise);
  }
function renderTierUpsell(cart, rule, subtotal) {
  const el = document.getElementById("fsb-tier-upsell");
  if (!el) return;

  // Show ONLY when 10% rule is active
  if (!rule || rule.percent !== 10) {
    el.style.display = "none";
    el.innerHTML = "";
    return;
  }

  // Extra savings if user goes from 10% → 15% = additional 5%
  const extraPaise = Math.round(subtotal * 0.05);

  el.style.display = "block";
  el.innerHTML = `
    <strong>Add 1 more pair</strong> to unlock <strong>15% OFF</strong>
    <div class="fsb-tier-upsell__sub">
      Extra savings: ${moneyINRRounded(extraPaise)}
    </div>
  `;
}

// Shipping: SHIP150 = ₹150 per pair (always). SHIP300 = ₹300 per pair (always). No tag = free if net price ≥ ₹1500, else ₹150 per pair.
const FREE_SHIPPING_THRESHOLD_PAISE = 1500 * 100;

async function computeShipping(cart, discountPaise) {
  const netPricePaise = (cart.total_price || 0) - (discountPaise || 0);
  const netBelowThreshold = netPricePaise < FREE_SHIPPING_THRESHOLD_PAISE;
  let shipping = 0; // rupees

  for (const item of cart.items) {
    const qty = item.quantity;
    const product = await fetchProduct(item.handle);
    const rawTags = product && product.tags ? product.tags : [];
    const tags = Array.isArray(rawTags)
      ? rawTags.map(t => String(t).toUpperCase().trim())
      : String(rawTags).split(",").map(t => t.toUpperCase().trim());

    if (tags.includes("SHIP300")) {
      shipping += 300 * qty; // ₹300 per pair
    } else if (tags.includes("SHIP150")) {
      shipping += 150 * qty; // ₹150 per pair
    } else if (netBelowThreshold) {
      shipping += 150 * qty; // no tag, net price below 1500: ₹150 per pair
    }
    // no tag + net ≥ 1500: free (add 0)
  }

  return shipping * 100; // return paise
}

async function update() {
  try {
    const cart = await getCart();
    if (cart.item_count === 0) {
      render(cart, null, 0, 0, 0, 0);
      renderTierUpsell(cart, null, 0);
      renderLineItemStrikeThrough(cart, null, []);
      return;
    }
    // Prefetch all products in parallel so MRP/shipping/eligible use cache (no sequential lag)
    await Promise.all(cart.items.map(function (item) { return fetchProduct(item.handle); }));
    const [mrpPaise, eligibleResult] = await Promise.all([
      computeMRP(cart),
      computeEligible(cart)
    ]);
    const { qty, subtotal, saleFlags } = eligibleResult;
    const rule = bestRule(qty);
    const discountPaise = (rule && subtotal > 0) ? Math.round(subtotal * (rule.percent / 100)) : 0;
    const shipping = await computeShipping(cart, discountPaise);

    render(cart, rule, discountPaise, shipping, mrpPaise, subtotal || 0);
    renderTierUpsell(cart, rule, subtotal);
    renderLineItemStrikeThrough(cart, rule, saleFlags);
  } catch (e) {
    console.log("FSB CART ERROR:", e);
  }
}


  // Force apply discount code on checkout click
  function bindCheckout() {
    document.addEventListener("click", function (e) {
      const btn = e.target.closest(".checkout-buttons a.btn, a.btn[href='/checkout']");
      if (!btn) return;

      const code = getCookie("fsb_discount_code");
      if (!code) return;

      e.preventDefault();
      window.location.href = `/discount/${encodeURIComponent(code)}?redirect=/checkout`;
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    update();
    bindCheckout();
  });

  // Update after cart changes
  // ===== Reliable live updates in Symmetry cart drawer =====
  function debounce(fn, wait) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  const debouncedUpdate = debounce(update, 120);

  function watchCartDrawer() {
    const drawer = document.querySelector("cart-drawer");
    if (!drawer) return;

    // When drawer DOM changes (qty, remove, add), update after the HTML settles
    const observer = new MutationObserver(() => {
      debouncedUpdate();
    });

    observer.observe(drawer, {
      subtree: true,
      childList: true,
      characterData: true
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    watchCartDrawer();
  });

  // Run update as soon as cart drawer is about to open so MRP/discount load with minimal lag
  document.addEventListener("on:cart-drawer:before-open", function () {
    update();
  });

  // Also run update right after any click on qty/remove for instant feedback
  document.addEventListener("click", function (e) {
    if (
      e.target.closest(".f-quantity__button") ||
      e.target.closest(".f-cart-drawer__remove") ||
      e.target.closest('form[action="/cart/add"]')
    ) {
      setTimeout(update, 200);
      setTimeout(update, 600);
    }
  });
})();